/* ============================================================
   og-product.js
   产品页专属JS
   当前包含：04 Sticky Mobile ATC
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     04 Sticky Mobile ATC
     逻辑：
     1. Intersection Observer 监听右栏ATC按钮，离开视口后显示Sticky
     2. 监听variant change，同步价格+规格文案
     3. 未选尺码时按钮变"Select Size"，点击滚动回Buy Box
     4. 已选尺码时fetch加购，复用og-pdp-hero的加购逻辑
     ============================================================ */

  var stickyBar    = document.getElementById('og-pdp-sticky-atc');
  var stickyBtn    = document.getElementById('og-sticky-atc-btn');
  var stickyBtnTxt = document.getElementById('og-sticky-btn-text');
  var stickyPrice  = document.getElementById('og-sticky-price');
  var stickyVariant = document.getElementById('og-sticky-variant');

  /* 监听目标：右栏ATC按钮离开视口后显示Sticky */
  var watchTarget = document.querySelector('.og-pdp-hero__amz-atc');

  if (!stickyBar || !watchTarget) return;

  /* ── 1. Intersection Observer：监听右栏ATC按钮可见性 ── */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        /* 右栏ATC可见 → 隐藏Sticky */
        stickyBar.classList.remove('og-pdp-sticky-atc--visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      } else {
        /* 右栏ATC不可见 → 显示Sticky */
        stickyBar.classList.add('og-pdp-sticky-atc--visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      }
    });
  }, { threshold: 0 });

  observer.observe(watchTarget);

  /* ── 2. 同步价格和规格文案 ── */
  function getStickyVariantText() {
    var colorEl = document.getElementById('og-selected-color');
    var sizeEl  = document.getElementById('og-selected-size');
    var parts   = [];
    if (colorEl && colorEl.textContent.trim()) parts.push(colorEl.textContent.trim());
    if (sizeEl  && sizeEl.textContent.trim())  parts.push('Size ' + sizeEl.textContent.trim());
    return parts.join(' · ');
  }

  function isSizeSelected() {
    var checked = document.querySelector('.og-pdp-hero__size-input:checked');
    /* 如果产品没有尺码选项，视为已选 */
    var sizeInputs = document.querySelectorAll('.og-pdp-hero__size-input');
    if (sizeInputs.length === 0) return true;
    return !!checked;
  }

  function updateStickyBar() {
    /* 同步价格 */
    var priceEl = document.querySelector('.og-pdp-hero__amz-price-main');
    if (priceEl && stickyPrice) {
      stickyPrice.textContent = priceEl.textContent;
    }

    /* 同步规格文案 */
    if (stickyVariant) {
      stickyVariant.textContent = getStickyVariantText();
    }

    /* 同步按钮状态 */
    if (isSizeSelected()) {
      if (stickyBtnTxt) stickyBtnTxt.textContent = 'Buy Now';
      if (stickyBtn) {
        stickyBtn.classList.remove('og-pdp-sticky-atc__button--select-size');
      }
    } else {
      if (stickyBtnTxt) stickyBtnTxt.textContent = 'Select Size';
      if (stickyBtn) {
        stickyBtn.classList.add('og-pdp-sticky-atc__button--select-size');
      }
    }
  }

  /* 监听color和size变化 */
  document.querySelectorAll('.og-pdp-hero__color-input, .og-pdp-hero__size-input')
    .forEach(function (input) {
      input.addEventListener('change', updateStickyBar);
    });

  /* 初始化 */
  updateStickyBar();

  /* ── 3. 按钮点击逻辑 ── */
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {

      /* 未选尺码：滚动回Buy Box尺码区 */
      if (!isSizeSelected()) {
        var sizeSection = document.querySelector('.og-pdp-hero__size');
        if (sizeSection) {
          sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          /* 轻微抖动提示 */
          sizeSection.style.transition = 'outline 0.2s';
          sizeSection.style.outline = '2px solid var(--og-gold)';
          setTimeout(function () { sizeSection.style.outline = 'none'; }, 1200);
        }
        return;
      }

      /* 已选尺码：fetch加购，复用og-pdp-hero的加购逻辑 */
      var variantIdInput = document.getElementById('og-variant-id');
      var qtySelect      = document.getElementById('og-amz-qty-select');
      var vid = variantIdInput ? variantIdInput.value : '';
      var qty = qtySelect     ? qtySelect.value      : '1';

      if (!vid) return;

      /* 按钮loading状态 */
      stickyBtn.disabled = true;
      if (stickyBtnTxt) stickyBtnTxt.textContent = 'Adding...';

      /* Step 1：加购 */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid), quantity: parseInt(qty) })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        /* Step 2：Section Rendering API 刷新bubble + drawer */
        return fetch('/?sections=cart-icon-bubble,cart-drawer');
      })
      .then(function (res) { return res.json(); })
      .then(function (sections) {

        /* 更新右上角bubble */
        var bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl && sections['cart-icon-bubble']) {
          var parsedBubble = new DOMParser().parseFromString(
            sections['cart-icon-bubble'], 'text/html'
          );
          var bubbleInner = parsedBubble.querySelector('.shopify-section');
          if (bubbleInner) bubbleEl.innerHTML = bubbleInner.innerHTML;
        }

        /* 更新Cart Drawer */
        var drawerEl = document.getElementById('CartDrawer');
        if (drawerEl && sections['cart-drawer']) {
          var parsedDrawer = new DOMParser().parseFromString(
            sections['cart-drawer'], 'text/html'
          );
          var drawerInner = parsedDrawer.querySelector('#CartDrawer');
          if (drawerInner) drawerEl.innerHTML = drawerInner.innerHTML;
        }

        /* 恢复按钮 */
        stickyBtn.disabled = false;
        if (stickyBtnTxt) stickyBtnTxt.textContent = 'Buy Now';
      })
      .catch(function (err) {
        console.error('Sticky ATC error:', err);
        stickyBtn.disabled = false;
        if (stickyBtnTxt) stickyBtnTxt.textContent = 'Buy Now';
      });
    });
  }

})();
